import { z } from 'zod'
import { PROMPT_CATEGORIES } from '../../../types/prompt'
import { REVIEW_MODES } from '../../../types/review-mode'

export const ReviewModeDtoSchema = z.enum(REVIEW_MODES)

export const PromptCategoryDtoSchema = z.enum(PROMPT_CATEGORIES)

const PromptCategoryFieldDtoSchema = z.preprocess(
  (value) => (typeof value === 'string' ? value.trim() : value),
  PromptCategoryDtoSchema.nullable().optional()
)

export const PromptDtoSchema = z.object({
  prompt_id: z.string(),
  title: z.string(),
  description: z.string(),
  category: PromptCategoryFieldDtoSchema,
  user_prompt: z.string(),
  llm_model: z.string(),
  prompt_type: z.string(),
  system_prompt: z.string().optional(),
  created_at: z.iso.datetime({ offset: true }),
  updated_at: z.iso.datetime({ offset: true }),
  is_favorited: z.boolean().optional(),
  is_qc_prompt: z.boolean().optional(),
  review_mode: ReviewModeDtoSchema.nullable().optional(),
  requires_document_comments: z.boolean().optional(),
  requires_full_document: z.boolean().optional(),
})

export const CreatePromptResponseDtoSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  prompt: PromptDtoSchema.optional(),
})

export const GetPromptsResponseDtoSchema = z.object({
  success: z.boolean(),
  favorites: z.array(PromptDtoSchema),
  standard: z.array(PromptDtoSchema),
  custom: z.array(PromptDtoSchema),
  total: z.number(),
})

export const DeletePromptResponseDtoSchema = z.object({
  success: z.boolean(),
  message: z.string(),
})

export const ToggleFavoriteResponseDtoSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  is_favorited: z.boolean(),
})

export type PromptDto = z.infer<typeof PromptDtoSchema>
export type CreatePromptResponseDto = z.infer<typeof CreatePromptResponseDtoSchema>
export type GetPromptsResponseDto = z.infer<typeof GetPromptsResponseDtoSchema>
export type DeletePromptResponseDto = z.infer<typeof DeletePromptResponseDtoSchema>
export type ToggleFavoriteResponseDto = z.infer<typeof ToggleFavoriteResponseDtoSchema>
